// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = ({ onAdmissionClick }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMobileMenuOpen(false);
    };

    const handleAdmissionClick = () => {
        if (onAdmissionClick) {
            onAdmissionClick();
        }
        setIsMobileMenuOpen(false);
    };

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="nav-container">
                {/* Logo */}
                <div className="nav-logo" onClick={() => scrollToSection('hero')}>
                    <img 
                        src="/images/logo.png" 
                        alt="SriChem Logo" 
                        className="nav-logo-img"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                    <div className="logo-fallback">
                        SriChem
                    </div>
                </div>

                {/* Desktop Navigation */}
                <div className="desktop-nav-wrapper">
                    <ul className="nav-menu">
                        <li><button onClick={() => scrollToSection('hero')}>Home</button></li>
                        <li><button onClick={() => scrollToSection('about')}>About</button></li>
                        <li><button onClick={() => scrollToSection('results')}>Results</button></li>
                        <li><button onClick={() => scrollToSection('courses')}>Courses</button></li>
                        <li><button onClick={() => scrollToSection('gallery')}>Gallery</button></li>
                        <li><button onClick={() => scrollToSection('feedback')}>Reviews</button></li>
                        <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
                    </ul>
                    
                    <button onClick={handleAdmissionClick} className="admission-badge-desktop">
                        <span>🎓</span>
                        <div>
                            <div>Admissions Open</div>
                            <div className="admission-year">2027-28</div>
                        </div>
                    </button>
                </div>

                {/* Mobile View */}
                <div className="mobile-controls">
                    <div className="mobile-buttons">
                        <button className="mobile-results" onClick={() => scrollToSection('results')}>
                            <span>🏆</span> Results
                        </button>
                        <button className="mobile-admission" onClick={handleAdmissionClick}>
                            <span>🎓</span> Admissions
                        </button>
                    </div>
                    
                    <div 
                        className={`mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                {/* Mobile Dropdown */}
                <div className={`mobile-dropdown ${isMobileMenuOpen ? 'active' : ''}`}>
                    <button onClick={() => scrollToSection('hero')}>Home</button>
                    <button onClick={() => scrollToSection('about')}>About</button>
                    <button onClick={() => scrollToSection('courses')}>Courses</button>
                    <button onClick={() => scrollToSection('gallery')}>Gallery</button>
                    <button onClick={() => scrollToSection('feedback')}>Reviews</button>
                    <button onClick={() => scrollToSection('contact')}>Contact</button>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;